(function () {
    'use strict';

    const CONSENT_VERSION = 1;
    const STORAGE_KEY = 'bc-cookie-consent';

    if (window.__bcCookieBannerBooted) return;
    window.__bcCookieBannerBooted = true;

    function readConsent() {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            if (!raw) return null;
            return JSON.parse(raw);
        } catch (_) {
            return null;
        }
    }

    function writeConsent() {
        try {
            localStorage.setItem(
                STORAGE_KEY,
                JSON.stringify({
                    v: CONSENT_VERSION,
                    t: Date.now(),
                }),
            );
        } catch (_) {
            // private mode etc
        }
    }

    function init() {
        const banner = document.getElementById('cookieBanner');
        const btn = document.getElementById('cookieBannerOk');
        if (!banner || !btn) return;

        const existing = readConsent();
        if (existing && existing.v >= CONSENT_VERSION) return;

        setTimeout(function () {
            banner.classList.add('show');

            banner.offsetHeight;
            banner.classList.add('in');
        }, 400);

        btn.addEventListener('click', function () {
            writeConsent();
            banner.classList.remove('in');
            setTimeout(function () {
                banner.classList.remove('show');
            }, 250);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
